import * as Yup from "yup";

// Multi-lingual support
import { t } from "i18next";

// Validation schemas for communication details
export const getCommunicationDetailsValidationSchema = () =>
  Yup.object({
    countryCode: Yup.string().required(
      t("addUpdateFarmer.countryCodeRequired"),
    ),
    mobileNumber: Yup.string().when("countryCode", ([countryCode]) => {
      // If the countryCode is 'TH', validate the length as 9
      return countryCode === "+66"
        ? Yup.string()
            .length(9, t("addUpdateFarmer.mobileNumberInvalid"))
            .required(t("addUpdateFarmer.mobileNumberRequired"))
        : Yup.string()
            .length(10, t("addUpdateFarmer.mobileNumberInvalid"))
            .required(t("addUpdateFarmer.mobileNumberRequired"));
    }),
    address: Yup.string()
      .trim()
      // .min(10, t("addUpdateFarmer.addressMin"))
      .max(100, t("addUpdateFarmer.addressMax")),
    // .required(t("addUpdateFarmer.addressRequired")),
    // province: Yup.string().required(t("addUpdateFarmer.provinceRequired")),
    // district: Yup.string().required(t("addUpdateFarmer.districtRequired")),
    // subdistrict: Yup.string().required(
    //   t("addUpdateFarmer.subdistrictRequired"),
    // ),
    // postalcode: Yup.string().required(t("addUpdateFarmer.postalcodeRequired")),
    village: Yup.string().max(50, t("addUpdateFarmer.villageMax")),
  });
